export enum RaffleDefaultDrawScheduleStatusEnum {
  WAITING = "w",
  PROCESSING = "p",
  DONE = "d",
  FAILED = "f",
  CANCELED = "c",
}

export type RaffleDefaultDrawScheduleStatusTypes =
  `${RaffleDefaultDrawScheduleStatusEnum}`;

export enum RaffleDefaultDrawScheduleTypeEnum {
  LOTTERY = "lottery",
  RANDOM = "random",
}

export type RaffleDefaultDrawScheduleTypes =
  `${RaffleDefaultDrawScheduleTypeEnum}`;
